import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { PrequalsGreenSkyDisclosure } from './PrequalsGreenSkyDisclosure';

export const PrequalsDisclosuresContainer = () => {
    const { disclosureBlocks = [] } = useProviderConfig();

    return (
        <>
            {disclosureBlocks.map(block => {
                switch (block) {
                    case 'greenSky':
                        return <PrequalsGreenSkyDisclosure key="prequals-disclosure-greenSky" />;
                    default:
                        return null;
                }
            })}
        </>
    );
};
